import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectNavDenominatorMode,
  selectPositionCalculationMode,
  setNavDenominatorMode,
  setPositionCalculationMode,
} from "../../../Redux/Reducers/uiSlice";
import {
  NAV_DENOMINATOR_MODE_OPTIONS,
  POSITION_CALCULATION_MODE_OPTIONS,
} from "../../../utils/positionCalculationMode";
import { v2ControlFieldSx, v2SelectLabelSx } from "../v2Theme";

/**
 * V2-only calculation mode controls (dropdowns).
 * Does not replace PositionsCalculationToggle used elsewhere.
 */
const PositionsCalculationControlsV2 = ({ sx }) => {
  const dispatch = useDispatch();
  const mode = useSelector(selectPositionCalculationMode);
  const navDenominatorMode = useSelector(selectNavDenominatorMode);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flexWrap: "wrap",
        ...sx,
      }}
    >
      <FormControl
        size="small"
        sx={{ ...v2ControlFieldSx({ sm: 280, min: 280 }), minWidth: 280 }}
      >
        <InputLabel id="v2-position-mode-label" sx={v2SelectLabelSx}>
          Position view
        </InputLabel>
        <Select
          labelId="v2-position-mode-label"
          value={mode}
          label="Position view"
          onChange={(e) => dispatch(setPositionCalculationMode(e.target.value))}
          sx={{
            color: "text.primary",
            fontSize: "0.95rem",
            "& .MuiSelect-select": {
              py: 1,
              pr: "32px !important",
            },
          }}
        >
          {POSITION_CALCULATION_MODE_OPTIONS.map(({ value, label }) => (
            <MenuItem
              key={value}
              value={value}
              sx={{ fontSize: "0.95rem", whiteSpace: "normal" }}
            >
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        size="small"
        sx={{ ...v2ControlFieldSx({ sm: 210, min: 210 }), minWidth: 210 }}
      >
        <InputLabel id="v2-nav-mode-label" sx={v2SelectLabelSx}>
          Capital mode
        </InputLabel>
        <Select
          labelId="v2-nav-mode-label"
          value={navDenominatorMode}
          label="Capital mode"
          onChange={(e) => dispatch(setNavDenominatorMode(e.target.value))}
          sx={{
            color: "text.primary",
            fontSize: "0.95rem",
            "& .MuiSelect-select": {
              py: 1,
              pr: "32px !important",
            },
          }}
        >
          {NAV_DENOMINATOR_MODE_OPTIONS.map(({ value, label }) => (
            <MenuItem
              key={value}
              value={value}
              sx={{ fontSize: "0.95rem", whiteSpace: "normal" }}
            >
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PositionsCalculationControlsV2;
